import { render, staticRenderFns } from "./myuser-file-upload.vue?vue&type=template&id=8235aab2"
import script from "./myuser-file-upload.vue?vue&type=script&lang=js"
export * from "./myuser-file-upload.vue?vue&type=script&lang=js"
import style0 from "./myuser-file-upload.vue?vue&type=style&index=0&id=8235aab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports